import { Link } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { isServiceAeroGCS, Popup } from './reusableFunctions'
import AeroMeghLogo from "../aeromegh-logo-new.png";
import GREEN from '../assets/sideBarIcons/green-icon.png'
import { sideBarPaths } from '../sideBarPaths';
import Help from "../sidebaricon/Help-new.png"
import HelpInactive from "../sidebaricon/Help-Inactive.png"
import Apps from "../sidebaricon/Apps.png"
import AppsInactive from "../sidebaricon/Apps-Inactive.png"
import * as API from '../api'
import { useSelector } from 'react-redux';
import Tippy from '@tippyjs/react';
import CloseIcon from "../icons/blackClose.png"
import leaseIcon from '../icons/leaseIcon.svg'
import { ADMIN_USERS, FEATURE_NOT_AVAILABLE_FOR_FREE_USERS_MESSAGE } from '../AppConstants';
import AdminOrthoImporter from '../AdminOrthoImporter';
import { useIsFreePlan } from '../redux/Profile/useSubscription';
import Corola from '../../src/AeroGCSEnterprise/assets/icons/Coroa.svg'    
import UpgradeIcon from '../../src/AeroGCSEnterprise/assets/icons/Master.svg'



const SideBarComponent = (props) => {
    const location = useLocation()
    const history = useHistory()
    const sideBarState = useSelector(state => state.sidebar)
    const [route, setRoute] = useState(sideBarPaths[location.pathname])
    const [user, setUser] = useState();
    const [type, setType] = useState()
    const [openApps, setOpenApps] = useState(false)
    const [isGreenPath, setIsGreenPath] = useState(false)
    const activeProfile = useSelector((state) => state.profile)
    const isFreePlan = useIsFreePlan();


    useEffect(() => {
        if (location.pathname) {
            setRoute(sideBarPaths[location.pathname])
            setIsGreenPath(location.pathname.includes("green_") ? true : false)
        }
    }, [location.pathname])

    useEffect(() => {
        if (!user)
            API.getUserType().then(([blah, type, user]) => {
                setUser(user);
                setType(type)
            })
    }, [])

    useEffect(() => {
        setUser(activeProfile.user)
    }, [activeProfile.user])

    const [apps, setApps] = useState([
        {
            backgroundColor: '#238E28',
            icon: GREEN,
            text: "Green",
            redirectTo: `/aerogcsenterprise/green_dashboard`,
        },
        {
            backgroundColor: '#2989CF',
            icon: leaseIcon,
            text: "Lease",
            redirectTo: `/aerogcsenterprise/lease_dashboard`,
        },
    ])

    const isToolSelected = (item) => {
        if (!item) return false
        return route.selectedPath === item.path
    }
    const toolJSX = (item) => {
        const handleItemClick = (e) => {
            e.preventDefault();
            // If item has disableForFreeUsers flag and user is on free plan, show modal
            if (item.disableForFreeUsers) {
                Popup.alert("WARNING_NOTE", FEATURE_NOT_AVAILABLE_FOR_FREE_USERS_MESSAGE, () => {
                    history.push("/aeroGCS_plans", { user: activeProfile.user || user, serviceName: "AeroGCS Enterprise", currentPlan: (activeProfile.user || user)?.sub });
                }, () => { });
                return;
            }
            // Otherwise, proceed with normal onClick or navigation
            else if (item.onClick) {
                item.onClick(e);
            }
        };

        return <div style={{ borderLeft: `solid 2px ${isGreenPath && isToolSelected(item) ? '#238E28' : 'transparent'}` }}>
            <li>
                <Link
                    to={{ pathname: item.path, state: { config: { user, type }, user, serviceName: "AeroGCS Enterprise", currentPlan: activeProfile.user.sub, type, ...sideBarState } }} >
                    <div className="sidecontent-new" id="sidecontent">
                        <div className="sidebar-icon-wrapper">
                            {
                                item.disableForFreeUsers && isFreePlan ?
                                    <img
                                        src={Corola}
                                        className="corola-badge"
                                        alt="corola"
                                    /> : null
                            }


                            <div className="sidebar-icon-new">
                                <img
                                    className={`sidebar-icon-img-new ${item.className}`}
                                    src={isToolSelected(item) ? item.icon.active : item.icon.inActive}
                                    alt="serviceIcon"
                                />
                            </div>
                        </div>

                        {isToolSelected(item) ? (<div name="service" className={`sidebaropt-new ${isGreenPath && 'sidebaropt-new-Active'}`} style={{ color: isGreenPath ? '#238E28' : "#FFFFFF", fontWeight: 500, }} >{item.name}</div>)
                            : (<div style={{ color: isGreenPath ? '#FFFFFF' : '#FFFFFF99' }} name="service" className={"sidebaropt-new"}  >{item.name} </div>)}
                    </div>
                </Link>
            </li>
        </div>
    }

    return isServiceAeroGCS(location.pathname, props.adminService) && route ?
        <div className="sidebar-expanded-new"
            style={{ paddingTop: "0px", backgroundColor: isGreenPath ? '#052218' : '#081425', position: 'absolute', left: '0', top: 0, zIndex: 99 }} >
            <div style={{ display: "flex", transition: "0.3s", margin: 'auto', alignItems: 'center', justifyContent: 'center' }}>
                <img className='aeromegh-icon' src={AeroMeghLogo} />
            </div>
            <ul className="sidebar-nav-new" id="sidebar-nav-new">
                <div>
                    {route?.tools?.map((item) => {
                        if (item.path == '/admin/OEMUser') {
                            if (ADMIN_USERS.includes(user?.username)) {
                                return toolJSX(item)
                            }
                        } else {
                            return toolJSX(item)
                        }
                    })}

                    {window.location.pathname.includes('/admin') && ADMIN_USERS.includes(user?.username) && < div style={{ borderLeft: `solid 2px transparent` }}  >
                        <li>
                            <AdminOrthoImporter />
                        </li>
                    </div>}

                    {/* APPS */}
                    {!(window.location.pathname.includes('lease_') || window.location.pathname.includes('green_') || window.location.pathname.includes('/admin')) && <li>
                        <Tippy visible={openApps} interactive onClickOutside={() => setOpenApps(false)} className='apps-container' placement='right' content={<AppsContainer apps={apps} onClose={() => setOpenApps(false)} />}>
                            <div className="sidecontent-new" id="sidecontent" onClick={() => setOpenApps(prev => !prev)}>
                                <div className="sidebar-icon-new">
                                    <img className="sidebar-icon-img-new" src={openApps ? Apps : AppsInactive} alt="serviceIcon" />
                                </div>
                                {openApps ? (
                                    <div name="service" className={"sidebaropt-new"} style={{ color: "#FFFFFF", fontWeight: 500 }} >Apps</div>) : (
                                    <div style={{ color: '#FFFFFF99' }} name="service" className={"sidebaropt-new"}  > Apps </div>
                                )}
                            </div>
                        </Tippy>
                    </li>}
                    {/* Upgrade */}
                    { isFreePlan && toolJSX({
                        name: 'Upgrade', path: "/aeroGCS_plans",
                        icon: { active: UpgradeIcon, inActive: UpgradeIcon },
                        onClick: () => {
                            history.push("/aeroGCS_plans", { user: activeProfile.user || user, serviceName: "AeroGCS Enterprise", currentPlan: (activeProfile.user || user)?.sub });
                        }
                    })}

                    {/* HELP TOOL */}
                    {toolJSX({
                        name: 'Help', path: "/help",
                        icon: { active: Help, inActive: isGreenPath ? Help : HelpInactive },
                        onClick: () => {
                            const url = `https://aerogcs.com/aerogcs-enterprise-manual/aerogcs-enterprise`
                            window.open(url, "_blank");
                        }
                    })}
                </div>
            </ul >
        </div >
        : <></>
}

export default SideBarComponent


const AppsContainer = ({ apps, onClose }) => {
    return <>
        <img src={CloseIcon} className='apps-close-icon' onClick={onClose} />
        <div className='apps-title'>Applications</div>
        <div className='apps-grid'>
            {apps.map(app => <Link onClick={onClose} to={{ pathname: app.redirectTo, state: app.state }}>
                <div className='apps-icon-container' style={{ background: app.backgroundColor }}>
                    <img style={{ width: "100%" }} src={app.icon} />
                </div>
                <div className='apps-name'>{app.text}</div>
            </Link>)}
        </div>
    </>
}